export default __webpack_public_path__ + "static/media/order-2.b738df2f.png";